var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import { getSessionStoragePrefs, removeSessionStoragePrefs, setSessionStoragePrefs, } from "../Storage";
import CloseWidgetPanel from "./CloseWidgetPanel";
import { widgetFooterTabs } from "../App";
import { AppContext } from "../appContext";
import { InteractiveFlowNodes, InteractiveNodeTypes, } from "./InteractiveFlowUtils";
import { CUSTOMER, EXECUTE_FLOW_NODE_URL_PATH, EXECUTION_LIST_FETCH_URL_PATH, OPENED_CHAT, OPENED_FLOW, START_FLOW_URL_PATH, VISITOR_UUID, } from "../globals";
import { getReq, postReq } from "../request";
import IrrelevantNode from "./interactiveNodes/IrrelevantNode";
import { getFormMetaData } from "../Utils";
var InteractiveFlow = function (props) {
    var parentContext = useContext(AppContext);
    var chatPrefs = parentContext.chatPrefs, changeActiveTab = parentContext.changeActiveTab;
    var chatFlows = chatPrefs.flowPrefs;
    var detectedChatFlow = chatFlows === null || chatFlows === void 0 ? void 0 : chatFlows.find(function (flow) { return flow.id == getSessionStoragePrefs(OPENED_FLOW); });
    if (!detectedChatFlow) {
        changeActiveTab(widgetFooterTabs.Home);
    }
    var chatFlow = useState(detectedChatFlow ? detectedChatFlow : {})[0];
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState({}), executionMeta = _b[0], setExecutionMeta = _b[1];
    var _c = useState([]), executionList = _c[0], setExecutionList = _c[1];
    useEffect(function () {
        // Start chat flow
        var flowExecutionId = getSessionStoragePrefs("flow_execution_id");
        if (flowExecutionId) {
            // Get exections and set data
            getFlowExecution(flowExecutionId);
        }
        else {
            // Start flow
            startFlowExecution();
        }
    }, []);
    var getFlowExecution = function (flowExecutionId) { return __awaiter(void 0, void 0, void 0, function () {
        var wait;
        return __generator(this, function (_a) {
            wait = getReq(EXECUTION_LIST_FETCH_URL_PATH + flowExecutionId, {});
            wait
                .then(function (response) {
                setLoading(false);
                if (!response.data ||
                    !response.data.executionMeta ||
                    !response.data.executionList) {
                    startFlowExecution();
                    return;
                }
                setExecutionMeta(__assign({}, response.data.executionMeta));
                setExecutionList(__spreadArray([], response.data.executionList, true));
                setScrollBottom();
            })
                .catch(function () {
                startFlowExecution();
            });
            return [2 /*return*/];
        });
    }); };
    var executeNodeOnUserInteraction = function (execution) {
        var wait = postReq(EXECUTE_FLOW_NODE_URL_PATH, execution);
        setLoading(true);
        wait
            .then(function (response) {
            var _a, _b, _c, _d, _e, _f;
            setLoading(false);
            var newExecutionList = response.data.executionList;
            setExecutionMeta(__assign({}, response.data.executionMeta));
            if ((_b = (_a = response.data.executionMeta) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.customer)
                setSessionStoragePrefs(CUSTOMER, JSON.stringify((_d = (_c = response.data.executionMeta) === null || _c === void 0 ? void 0 : _c.info) === null || _d === void 0 ? void 0 : _d.customer));
            // Write logic to update existing ids, and push new executions
            setExecutionList(__spreadArray(__spreadArray([], executionList.filter(function (execution) { return execution.id != newExecutionList[0].id; }), true), newExecutionList, true));
            if ((_e = newExecutionList[newExecutionList.length - 1].info) === null || _e === void 0 ? void 0 : _e.session) {
                var session = newExecutionList[newExecutionList.length - 1].info.session;
                removeSessionStoragePrefs(OPENED_CHAT);
                removeSessionStoragePrefs("flow_execution_id");
                props.addNewSession(session);
                setSessionStoragePrefs(OPENED_CHAT, session.id);
                props.showConversation();
            }
            else if (newExecutionList[newExecutionList.length - 1].isExecuted &&
                !newExecutionList[newExecutionList.length - 1].nextNodeId &&
                newExecutionList[newExecutionList.length - 1].node.data.nodeType ==
                    InteractiveNodeTypes.END &&
                ((_f = newExecutionList[newExecutionList.length - 1].node.data.formData) === null || _f === void 0 ? void 0 : _f.action) == "end") {
                removeSessionStoragePrefs(OPENED_CHAT);
                removeSessionStoragePrefs("flow_execution_id");
                goBack();
            }
            setScrollBottom();
        })
            .catch(function () {
            setLoading(false);
        });
    };
    var startFlowExecution = function () { return __awaiter(void 0, void 0, void 0, function () {
        var wait;
        var _a;
        return __generator(this, function (_b) {
            wait = postReq(START_FLOW_URL_PATH + "/" + chatFlow.id + "/" + VISITOR_UUID, {
                id: chatFlow.id,
                meta_data: JSON.stringify(getFormMetaData()),
                matched_bot_id: (_a = chatPrefs.matchedBotPrefs) === null || _a === void 0 ? void 0 : _a.id
            });
            wait
                .then(function (response) {
                setLoading(false);
                if (!response.data ||
                    !response.data.executionMeta ||
                    !response.data.executionList)
                    return;
                // const newExecutionList = response.data.executionList;
                // if (
                //   newExecutionList[newExecutionList.length - 1].executed &&
                //   !newExecutionList[newExecutionList.length - 1].nextNodeId &&
                //   newExecutionList[newExecutionList.length - 1].node.data.nodeType ==
                //     InteractiveNodeTypes.END
                // ) {
                //   removeSessionStoragePrefs(OPENED_CHAT);
                //   removeSessionStoragePrefs("flow_execution_id");
                //   props.backToHome();
                //   return;
                // }
                setSessionStoragePrefs("flow_execution_id", response.data.executionMeta.id);
                setExecutionMeta(__assign({}, response.data.executionMeta));
                setExecutionList(__spreadArray([], response.data.executionList, true));
                setScrollBottom();
            })
                .catch(function () {
                setLoading(false);
            });
            return [2 /*return*/];
        });
    }); };
    var setScrollBottom = function () {
        // setTimeout(() => {
        var elem = document.getElementsByClassName("chat__messages-track")[0];
        if (elem)
            elem.scrollTop = elem.scrollHeight;
        // }, 100);
    };
    var getHeaderIcon = function () {
        return parentContext.chatPrefs.widget.default_profile_image;
    };
    var getHeaderName = function () {
        var _a, _b;
        if ((_a = chatPrefs.matchedFlowPrefs) === null || _a === void 0 ? void 0 : _a.id)
            return (_b = chatPrefs === null || chatPrefs === void 0 ? void 0 : chatPrefs.matchedFlowPrefs) === null || _b === void 0 ? void 0 : _b.name;
        return parentContext.chatPrefs.widget.title;
    };
    var goBack = function () {
        // Empty existing
        removeSessionStoragePrefs(OPENED_FLOW);
        removeSessionStoragePrefs("flow_execution_id");
        changeActiveTab(widgetFooterTabs.Home);
    };
    return (_jsxs("div", __assign({ className: "chat__conversation" }, { children: [_jsxs("div", __assign({ className: "chat__header" }, { children: [_jsxs("div", __assign({ className: "chat__header-action" }, { children: [_jsx("div", __assign({ "data-trigger": "all", className: "chat__header-back", onClick: function () { return goBack(); } }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", viewBox: "0 0 24 24", color: "currentColor" }, { children: _jsx("path", { stroke: "#fff", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.7", d: "m14 18-6-6 6-6" }) })) })), _jsxs("div", __assign({ className: "chat__header-user" }, { children: [_jsx("div", { children: _jsx("div", { className: "chat__header-user-img", style: { backgroundImage: 'url("' + getHeaderIcon() + '")' } }) }), _jsx("div", __assign({ className: "chat__header-user-title" }, { children: _jsxs("h1", __assign({ className: "chat__header-user-name" }, { children: [" ", getHeaderName(), " "] })) }))] }))] })), _jsx("div", __assign({ className: "chat__help-end" }, { children: _jsx(CloseWidgetPanel, {}) }))] })), _jsx("div", __assign({ className: "chat__content" }, { children: _jsxs("div", __assign({ className: "chat__messages" }, { children: [_jsx("div", __assign({ className: "chat__messages-track" }, { children: _jsxs("div", { children: [executionList &&
                                        executionList.length > 0 &&
                                        executionList.map(function (exe, index) {
                                            console.log(InteractiveFlowNodes);
                                            console.log(exe.node.type);
                                            var Node = exe.node.type !== "ACTION"
                                                ? InteractiveFlowNodes[exe.node.type]
                                                : InteractiveFlowNodes[exe.node.data.nodeType];
                                            if (exe.node.data.nodeType == InteractiveNodeTypes.END
                                            // &&
                                            // (exe.node.data.formData?.action == "agent" || exe.node.data.formData?.action == "end")
                                            )
                                                return _jsx(_Fragment, {});
                                            if ((exe.node.data.nodeType ==
                                                InteractiveNodeTypes.ORDER_SELECTION ||
                                                exe.node.data.nodeType ==
                                                    InteractiveNodeTypes.ITEM_SELECTION) &&
                                                executionMeta &&
                                                executionMeta.info &&
                                                !executionMeta.info.customerId) {
                                                return (_jsx(IrrelevantNode
                                                //   backToHome={props.backToHome}
                                                , { 
                                                    //   backToHome={props.backToHome}
                                                    content: "No customer available to fetch orders and items for" }));
                                            }
                                            if (exe.node.data.nodeType ==
                                                InteractiveNodeTypes.ITEM_SELECTION &&
                                                executionMeta &&
                                                executionMeta.info &&
                                                !executionMeta.info.orderId) {
                                                return (_jsx(IrrelevantNode
                                                //   backToHome={props.backToHome}
                                                , { 
                                                    //   backToHome={props.backToHome}
                                                    content: "No order available to select items from" }));
                                            }
                                            return (_jsx(_Fragment, { children: Node ? (_jsx(_Fragment, { children: _jsx(Node, { execution: exe, executionMeta: executionMeta, executeNodeOnUserInteraction: executeNodeOnUserInteraction }) })) : (_jsx(_Fragment, { children: JSON.stringify(exe) })) }));
                                        }), loading && _jsx("p", __assign({ style: { marginTop: "60px", textAlign: "center" } }, { children: _jsxs("div", __assign({ className: "chat__form-loader1" }, { children: [_jsx("span", {}), _jsx("span", {}), _jsx("span", {}), _jsx("span", {})] })) }))] }) })), _jsx("div", __assign({ className: "chat__messages-sign hide" }, { children: _jsxs("a", __assign({ target: "_blank" }, { children: ["We", _jsx("img", { src: "https://d2p078bqz5urf7.cloudfront.net/cloud/assets/livechat/love-icon.svg", width: "12px" }), "EngageBay"] })) }))] })) }))] })));
};
export default InteractiveFlow;
